module.exports = __webpack_public_path__ + "static/media/hp.b9ba3de2.png";